import React, { useEffect, useState } from 'react'
import { Button, ButtonGroup, ButtonOr, Form, Grid,  Loader,  Modal, Table } from 'semantic-ui-react'
import Components from '../../app/common/components';
import { observer } from 'mobx-react-lite';
import agent from '../../app/api/agent';
import { workflowSubTask } from '../../app/api/types';
import { columnType } from '../../app/common/components/DynamicRowsComponent';
import { store, useStore } from '../../app/stores/store';
import { historyInitialState } from '../../app/models/history';
import InspectionDetails from './InspectionDetails';


interface HFCTaskModalProps {
  isModal: boolean;
  setIsModal: (value: boolean) => void;
  shippingPrep: workflowSubTask; 
  title: string;
  selectedId:string;
  rowData?:any;
  setShippingPrep: (data: workflowSubTask | ((prevState: workflowSubTask) => workflowSubTask)) => void;
}
interface FilmCondition {
  [filmKey: string]: {
    [category: string]: {
      [property: string]: boolean;
    };
  };
}

const parseInspectionDetailStatus = (value?: string): FilmCondition[] => {
  if (!value || value.trim() === '') {
    return [];
  }

  try {
    const parsedValue = JSON.parse(value);
    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch (error) {
    console.error('Error parsing inspectionDetailStatus:', error, value);
    return [];
  }
};

const HFCTaskModal: React.FC<HFCTaskModalProps> = ({ isModal, setIsModal, shippingPrep,rowData, title, selectedId, setShippingPrep}) => {
   
const{dashboardStore, userStore}= useStore();
const [isButtonDisabled, setIsButtonDisabled] = useState(false);
const [inspectModal, setInspectModal] = useState(false);
const [filmConditions] = useState<FilmCondition[]>([]);
const[isLoading, setIsLoading] = useState(false);


useEffect(() => {
  const checkButtonDisabled = () => {
    let isEmpty = false;
    // Check if any mandatory elements are empty
    shippingPrep?.elements?.forEach(element => {
      if (element.isMandatory && element.elementValue === "") {
        isEmpty = true;
      }
    });

    let dynamicTableElementValue: any[] = [];
    let selectedOptionNames: string[] = [];
    shippingPrep?.elements?.forEach(element => {
      if (element.elementType === "DynamicTable" && element.isMandatory) {
        const jsonString = element.elementValue.replace("DynamicTable|", "");
        
        if (jsonString.trim() !== "") {
          dynamicTableElementValue = JSON.parse(jsonString);
        }
      }

      if (element.options) {
        element.options.forEach(option => {
          if (option.isSelected) {
            selectedOptionNames.push(option.optionName);
          }
        });
      }
    });

    // Only check if there are selected options and dynamic table values
    if (selectedOptionNames.length > 0 && dynamicTableElementValue.length > 0) {
      dynamicTableElementValue.forEach(obj => {
        selectedOptionNames.forEach(optionName => {
          if (Object.keys(obj).includes(optionName)) {
            // Check if the value is an empty string
            if (obj[optionName] === "") {
              isEmpty = true;
            }
            // Check if the value is an empty array
            else if (Array.isArray(obj[optionName]) && obj[optionName].length === 0) {
              isEmpty = true;
            }
          }
        });
      });
    }

    // Update the button disabled state based on the conditions
    setIsButtonDisabled(isEmpty);
    setShippingPrep({...shippingPrep});
  };

  checkButtonDisabled();
    //eslint-disable-next-line
}, [shippingPrep.elements]);


useEffect(() => {
  const fetchData = async () => {
    try {
      if (isModal && shippingPrep.subTaskName === 'Inspection Details') {
        // const inspectionDetailStatusItem = shippingPrep.elements.find((item: any) => item.elementName === 'Inspection Detail Status');
        // if (!inspectionDetailStatusItem || inspectionDetailStatusItem.elementValue === "") {
          const res = await agent.HFC.HFCInspectionDetails(selectedId);

          // Update elements in shippingPrep immutably
          const updatedElements = shippingPrep.elements.map(item => {
            if (item.elementName === "Inspection Detail Status") {
              return {
                ...item,
                elementValue: JSON.stringify(res.data) // or extract the specific property you need from res.data
              };
            }
            return item;
          });

          // Update shippingPrep state with updated elements
          setShippingPrep(prev => ({
            ...prev,
            elements: updatedElements
          }));
          const resp = await agent.HFC.HFCServiceElements(selectedId);
          setShippingPrep(resp.data)
        }
      // }
    } catch (error) {
      console.error('Error fetching inspection details:', error);
    }
  };

  fetchData();
    //eslint-disable-next-line
}, [isModal, selectedId, shippingPrep.subTaskName]);

useEffect(() => {
  const fetchData = async () => {
    try {
      if (isModal && shippingPrep.subTaskName === 'Inspection') {
      await agent.HFC.HFCInspection(selectedId);
      const res = await agent.HFC.HFCServiceElements(selectedId);
      const sortedElements = res.data.elements.sort((a:any, b:any) => a.elementIndex - b.elementIndex);
      const updatedElements = sortedElements.map((item: any) => {
        if (item.elementName === "Inspector" && item.elementValue === "") {
            item.elementValue = userStore.user?.displayName
        }
        return { ...item }; // Ensure immutability
    });
    setShippingPrep(prev => ({
      ...prev,  
      ...res.data,  
      elements: updatedElements,  
    }));
      }
    } catch (error) {
      console.error('Error fetching inspection details:', error);
    }
  };

  fetchData();
    //eslint-disable-next-line
}, [isModal, selectedId, shippingPrep.subTaskName]);


const formSubmittion = async() => {
  const formatDateTimeInIST = (date: Date): string => {
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'short',
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: 'Asia/Kolkata', // Use the Asia/Kolkata timezone for IST
    };
    
    return new Intl.DateTimeFormat('en-US', options).format(date);
  };

  const updatedInspectElements = [...shippingPrep.elements];

  updatedInspectElements.forEach((element: any, index: number) => {
    if (element.elementName === "Inspection Detail Status" && element.elementValue === "" && shippingPrep.subTaskName === 'Inspection Details') {
      updatedInspectElements[index] = {
        ...element,
        elementValue: JSON.stringify(filmConditions)
      };
    } else if (element.elementType === "DatePicker" && element.elementValue === "") {
      updatedInspectElements[index] = {
        ...element,
        elementValue: new Date().toLocaleDateString('en-IN', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        }),
      };
    } else if (element.elementType === "DateTime" && element.elementValue === "") {
      updatedInspectElements[index] = {
        ...element,
        elementValue: formatDateTimeInIST(new Date()),
      };
    }
  });

  setShippingPrep(prevShippingPrep => ({
    ...prevShippingPrep,
    elements: updatedInspectElements
  }));

  setIsModal(false);
  setInspectModal(true);
};


  const handleSubmit =async()=>{
      setIsLoading(true)
      const packageInfo = shippingPrep.elements.find(element => element.elementName === "Package Information");
      if (packageInfo) {
        let cleanedValue = packageInfo.elementValue.replace(/^DynamicTable\|/, '')
        let parsedValue = JSON.parse(cleanedValue);
        parsedValue.forEach((item:any, idx:any) => {
          item['Package No'] = (idx + 1).toString();  
        });
        packageInfo.elementValue = "DynamicTable|" + JSON.stringify(parsedValue);
      }
      
      await agent.HFC.HFCTaskElementUpdate(shippingPrep.elements)
      if(dashboardStore.dashboard.valueForL3Orders === "Shipping Prep"){
        const res = await agent.HFC.HFCShippingPrepSelected(selectedId);
        setShippingPrep(res.data)
      }
      if(shippingPrep.subTaskName === "Inspection"){
        
        const getElementValue = (name: string) => shippingPrep.elements.find(item => item.elementName === name)?.elementValue;
        const releaseDateElement = shippingPrep.elements.find(item => item.elementName === "Release Date");
        if (releaseDateElement && releaseDateElement.elementValue === "") {
          releaseDateElement.elementValue = new Date().toLocaleDateString('en-IN', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
          });
        }
        const payload = {
          grade: getElementValue('Overall Grade'),
          inspectionNotes: getElementValue('Inspection Notes'),
          aspectRatio: getElementValue('Aspect Ratio'),
          totalFootage: getElementValue('Total Footage'),
          color: getElementValue('Color'),
          sound: getElementValue('Sound'),
          language: getElementValue('Language'),
          releaseDate: getElementValue('Release Date'),
          directors: getElementValue('Directors')
        };
        
       await agent.HFC.HFCUpdateGrade(rowData.asset_ID, payload)
      }
      await formSubmittion()
      // generatePdfFunction()
      setIsLoading(false)
      setIsModal(false)
      setInspectModal(true)
  }
    const handleStart = async()=>{
      try {
        if(dashboardStore.dashboard.valueForL3Orders === "Services"){
         if(shippingPrep.subTaskName === 'Inspection'){
            await agent.HFC.HFCInspection(selectedId);
          }
          await agent.HFC.HFCServiceStartTask(selectedId, 1);
          const updatedShippingPrep= {...shippingPrep}
          updatedShippingPrep.status= 1
          updatedShippingPrep.subTaskstatus=1
          setShippingPrep(updatedShippingPrep)
          const payload ={
            ...historyInitialState,
            itemId: rowData.asset_ID, 
            status: `${store.userStore.user?.displayName} has started the task ${shippingPrep.subTaskName} for the asset "${title}"`,
            dateTime: new Date().toISOString(),
            trackerFromTime: new Date().toISOString(),
          }
          await agent.HFC.HFCaddHistory(payload)
        }        
        if(dashboardStore.dashboard.valueForL3Orders === "Shipping Prep"){
          const shippingPrepRes = await agent.HFC.HFCStartTask(selectedId);
          await agent.HFC.HFCContainerDetails(selectedId);
          const sortedElements = shippingPrepRes.data.elements.sort((a:any, b:any) => a.elementIndex - b.elementIndex);
          const updatedShippingPrep = { ...shippingPrepRes.data, elements: sortedElements};
          setShippingPrep(updatedShippingPrep)
          const payload ={
            ...historyInitialState,
            itemId: rowData.asset_ID,
            status: `${store.userStore.user?.displayName} has started the task ${shippingPrep.subTaskName} for the asset "${title}"`,
            dateTime: new Date().toISOString(),
            trackerFromTime: new Date().toISOString(),
          }
          await agent.HFC.HFCaddHistory(payload)
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    }
    }

    const handleStatus = async(param:number)=>{
      if(dashboardStore.dashboard.valueForL3Orders === "Services"){
        if(param === 2){
          if (param === 2) {
            setShippingPrep(prevShippingPrep => ({
                ...prevShippingPrep,
                status: 2,
                subTaskstatus: 2
            }));
        }
        const payload={
          ...historyInitialState,
          itemId: rowData.asset_ID,
          status: `${store.userStore.user?.displayName} has completed the task ${shippingPrep.subTaskName} for the asset "${title}"`,
          dateTime: new Date().toISOString(),
          trackerFromTime: new Date().toISOString(),
        }
        await agent.HFC.HFCaddHistory(payload)
        }
        if(param === 3){
          setShippingPrep(prevShippingPrep => ({
            ...prevShippingPrep,
            status: 3,
            subTaskstatus: 3
        }));
          const payload = {
            ...historyInitialState,
            itemId: rowData.asset_ID,
            status: `${store.userStore.user?.displayName} has hold the task ${shippingPrep.subTaskName} for the asset "${title}"`,
            dateTime: new Date().toISOString(),
            trackerFromTime: new Date().toISOString(),
          }
          await agent.HFC.HFCaddHistory(payload)
        }
        if(param === 4){
          setShippingPrep(prevShippingPrep => ({
            ...prevShippingPrep,
            status: 4,
            subTaskstatus: 4
        }));
          const payload = {
            ...historyInitialState,
            itemId: rowData.asset_ID,
            status: `${store.userStore.user?.displayName} has resumed the task ${shippingPrep.subTaskName} for the asset "${title}"`,
            dateTime: new Date().toISOString(),
            trackerFromTime: new Date().toISOString(),
          }
          await agent.HFC.HFCaddHistory(payload)
        }
        if(param!==2){
        await  agent.HFC.HFCServiceStartTask(selectedId,param)
      }

      }else{
        if(param === 2){
          if (param === 2) {
            setShippingPrep(prevShippingPrep => ({
                ...prevShippingPrep,
                status: 2,
                subTaskstatus: 2
            }));
        }
        }
        if(param!==2){
        await  agent.HFC.HFCTaskStatus(selectedId,param)
        const res = await agent.HFC.HFCShippingPrepSelected(selectedId);
        const sortedElements = res.data.elements.sort((a:any, b:any) => a.elementIndex - b.elementIndex);
        setShippingPrep({...res.data, elements: sortedElements})
        }
        if(param === 3){
        const payload = {
          ...historyInitialState,
          itemId: rowData.asset_ID,
          status: `${store.userStore.user?.displayName} has hold the task ${shippingPrep.subTaskName} for the asset "${title}"`,
          dateTime: new Date().toISOString(),
          trackerFromTime: new Date().toISOString(),
        }
        await agent.HFC.HFCaddHistory(payload)
        }
        if(param === 4){
          const payload = {
            ...historyInitialState,
            itemId: rowData.asset_ID,
            status: `${store.userStore.user?.displayName} has resumed the task ${shippingPrep.subTaskName} for the asset "${title}"`,
            dateTime: new Date().toISOString(),
            trackerFromTime: new Date().toISOString(),
          }
          await agent.HFC.HFCaddHistory(payload)
        }
      
       
      }
    }
    const openHold = async (param: number) => {
        await handleStatus(param);
      };

      // const generatePdfFunction = async () => {
      //   const generateData = (_dat: any) => {
      //     const result: any[] = [];
      //     shippingPrep?.elements.forEach((data: any) => {
      //       if (
      //         data.elementValue?.length !== '' ||
      //         data.files.length > 0 ||
      //         data.photos.length > 0
      //       ) {
      //         const description =
      //           data.elementType !== 'Dynamicmetadata' && data.elementName;
      //         let value =
      //           data.elementType !== 'DynamicTable'
      //             ? isArray(data.elementValue)
      //               ? data.elementValue?.join(', ')
      //               : data.elementValue?.replaceAll('|', ', ')
      //             : data.elementValue;
      //         if (data.elementType === 'AddFiles' && data.files.length > 0) {
      //           const fileNamesList: string[] = [];
      //           data.files?.forEach((f: FileType) => {
      //             fileNamesList.push(f.url);
      //           });
      //           value = fileNamesList.join(', ');
      //         }
      //         if (data.elementType === 'AddPhotograph' && data.photos.length > 0) {
      //           const photoNames: string[] = [];
      //           data.photos?.forEach((p: PhotoType) => {
      //             photoNames.push(p.url);
      //           });
      //           value = photoNames.join(', ');
      //         }
      //         if (data.elementType === 'DynamicTable') {
      //           const stringData = value?.split('DynamicTable|')?.[1];
      //           let tempValue =
      //             stringData !== undefined ? JSON.parse(stringData) : [];
      //           const rowsList: string[] = [];
      //           let columnHeaders: string[] = [];
      //           tempValue?.forEach((val: any) => {
      //             columnHeaders = Object.keys(val);
      //           });
      //           columnHeaders = columnHeaders?.filter((data) => data !== '_uuid_');
      //           tempValue?.forEach((val: any) => {
      //             let rowVal = '';
      //             columnHeaders?.forEach((header: string, index: number) => {
      //               rowVal += header?.split('_')?.join(' ');
      //               rowVal += ': ';
      //               rowVal += val?.[header];
      //               if (index !== columnHeaders.length - 1) {
      //                 rowVal += ', ';
      //               }
      //             });
      //             rowsList.push(rowVal);
      //           });
      //           value = rowsList.join('\n');
      //         }
      //         const elementDataTable: any = {
      //           Description: description,
      //           Values: value,
      //         };
      //         data.id = '1';
      //         result.push(Object.assign({}, elementDataTable));
      //       }
      //     });
      //     return result;
      //   };
    
      //   const createHeaders = (keys: any) => {
      //     var result = [];
      //     for (var i = 0; i < keys.length; i += 1) {
      //       result.push({
      //         id: keys[i],
      //         name: keys[i],
      //         prompt: keys[i],
      //         width: 133,
      //         align: 'center',
      //         padding: 0,
      //       });
      //     }
      //     return result;
      //   };
    
      //   const headers: any = createHeaders(['Description', 'Values']);
      //   const doc = new jsPDF({
      //     putOnlyUsedFonts: true,
      //     orientation: 'portrait',
      //   });
      //   let xPos = 5;
      //   let yPos = 35;
      //   doc?.addImage('https://res.cloudinary.com/drvaemi9t/image/upload/v1683893697/sfjftefmtkiye8bdk4vm.png', 'JPEG', 80, 6, 65, 20);
        
      //   doc?.table(xPos, yPos + 2, generateData(180), headers, {
      //     autoSize: false,
      //   });
    
      //   let subTaskConst: uploadFileType = {
      //     id: '',
      //     files: [],
      //   };
      //   let response: any = [];
      //     const blobPDF: any = new Blob([doc.output('blob')], {
      //       type: 'application/pdf',
      //     });
      //     response = await agent.Files.uploadFile(blobPDF);
      //     Object.assign(response.data, { fileId: uuid() });
      //     response.data.id = uuid();
      //     response.data.fileName = shippingPrep.subTaskName;
      //     subTaskConst = {
      //       // subTaskId: subTaskIdNo,
      //       id: selectedId,
      //       files: [
      //         {
      //           ...response.data,
      //           addedOn: new Date(),
      //         },
      //       ],
      //   }
      //   //history
      //   // updateHistoryMain("","","","","Values Submitted Successfully",activity?.id,"",false,"",[],[],activity,`updated ${mediaAssetStore.mediaAsset.taskformmodalhistoryinputplaceholder + "," + mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsplaceholder} from ${mediaAssetStore.mediaAsset.taskformmodalhistoryinputdefaultvalue + "," + mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsdefaultvalue} to ${mediaAssetStore.mediaAsset.taskformmodalhistoryinputvalue + "," + mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsvalue} `,activity?.title)//history
      //   // updateHistoryMain("","","","","Values Submitted Successfully",activity?.id,"",false,"",[],[],activity,`updated ${mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsplaceholder} from ${mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsdefaultvalue} to ${mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsvalue} `,activity?.title)//working history
      //   // mediaAssetStore.mediaAsset.taskformmodalhistoryinputvalue + mediaAssetStore.mediaAsset.taskformmodalhistoryinputdefaultvalue + mediaAssetStore.mediaAsset.taskformmodalhistoryinputplaceholder +
      //   // updateHistoryMain("","","","","Values Submitted Successfully",activity?.id,"",false,"",[],[],activity,`updated ${mediaAssetStore.mediaAsset.taskformmodalhistoryinputplaceholder +  `from ${mediaAssetStore.mediaAsset.taskformmodalhistoryinputdefaultvalue}` + `to ${mediaAssetStore.mediaAsset.taskformmodalhistoryinputvalue}` + "," + `updated ${mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsplaceholder}` + `from ${mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsdefaultvalue}` + `to ${mediaAssetStore.mediaAsset.taskformmodalhistoryoptionsvalue}`}`,activity?.title)//history
      //   await HFCgeneratePdf(subTaskConst);
      // };


    const openComplete = async(param:number)=> {
        await handleSubmit() 
        await handleStatus(param)
    }

    const openResume = async(param:number)=> {
        await handleStatus(param)
    }
    const saveDynamicTableData = async (
        data: any,
        validationData: any,
        removed: any,
        added: any,
        // alterHistory: string,
        initialElementValue: any,
        headers: columnType[],
      ) => {
        let copyElements = [...shippingPrep.elements];
        let indexOfData = copyElements?.findIndex(
        (localData: { templateElementId: string }) =>
            localData?.templateElementId === validationData?.templateElementId,
        );
        let payload = {
        ...validationData,
        elementValue: 'DynamicTable|' + JSON.stringify(data),
        };
        if (indexOfData < 0) {
        copyElements?.push(payload);
        } else {
        if (copyElements[indexOfData]) {
            copyElements[indexOfData] = payload;
        }
        }
        setShippingPrep(prevShippingPrep => ({
          ...prevShippingPrep,
          elements: copyElements
      }));
      };

     
    const onChangeHandler = async (e: any, data: any,validationData:any ) => {
        const updatedElements = shippingPrep.elements.map((item: any) => {
            if (item.elementName===data.name && item.elementType === "TextBox") {
                item.elementValue = data.value;
            }
            if (item.elementName===data.name && item.elementType === "TextArea") {
                item.elementValue =data.value;
            }
            if(item.elementType=== "DropDown" && item.elementName=== validationData.elementName) {
                item.elementValue = data.value;
            }
            if (item.elementType === "DateTime" && item.elementName === validationData.elementName) {
                item.elementValue = new Date(data).toDateString() +
                ' ' +
                new Date(data).toString().split(' ')[4]
            }
            if (item.elementType === "DatePicker" && item.elementName === validationData.elementName) {
                item.elementValue= e?.toLocaleDateString('en-IN', {
                  month: '2-digit',
                  day: '2-digit',
                  year: 'numeric',
              })
            }
            return item; 
        });
        setShippingPrep(prevShippingPrep => ({
          ...prevShippingPrep,
          elements: updatedElements
      }));
    };
    
    const renderTableHeaders = () => {
      // Find the 'Inspection Detail Status' element and get its value
      const inspectionDetailStatus = shippingPrep.elements.find((item: any) => item.elementName === 'Inspection Detail Status')?.elementValue;
    
      if (!inspectionDetailStatus) {
        return null; // Or handle the case where inspectionDetailStatus is not available
      }
    
      const parsedInspectionDetailStatus = parseInspectionDetailStatus(inspectionDetailStatus);
      if (parsedInspectionDetailStatus.length === 0) {
        return null;
      }

      const filmKeys = parsedInspectionDetailStatus.map((item: any) => Object.keys(item)[0]);
    
      return (
        <tr>
          <th>S.NO</th>
          {filmKeys.map((filmKey: any, index: any) => (
            <th key={index}>{filmKey}</th>
          ))}
        </tr>
      );
    };



    
const handleCheckboxChange = (filmKey: string, category: string, property: string, filmIndex: number): void => {
  // Find the element with elementName 'Inspection Detail Status'
  const inspectionDetailStatusItem = shippingPrep.elements.find((item: any) => item.elementName === 'Inspection Detail Status');
  
  if (inspectionDetailStatusItem) {
    const inspectionDetailStatus = parseInspectionDetailStatus(
      inspectionDetailStatusItem.elementValue,
    );
    
    // Toggle the property based on the provided indices
    if (inspectionDetailStatus[filmIndex] && inspectionDetailStatus[filmIndex][filmKey] && inspectionDetailStatus[filmIndex][filmKey][category]) {
      
      inspectionDetailStatus[filmIndex][filmKey][category][property] = !inspectionDetailStatus[filmIndex][filmKey][category][property];
      
      // Update shippingPrep state immutably
      setShippingPrep(prevShippingPrep => ({
        ...prevShippingPrep,
        elements: prevShippingPrep.elements.map((item: any) => {
          if (item.elementName === 'Inspection Detail Status') {
            return {
              ...item,
              elementValue: JSON.stringify(inspectionDetailStatus),
            };
          }
          return item;
        })
      }));
    } else {
      console.warn(`Invalid indices: filmIndex ${filmIndex}, filmKey ${filmKey}, category ${category}, property ${property}`);
    }
  } else {
    console.warn('Element with elementName "Inspection Detail Status" not found.');
  }
};
    
const renderTableBody = () => {
  const elementValue = shippingPrep.elements.find(
    item => item.elementName === "Inspection Detail Status"
  )?.elementValue;

  const parsedElementValue = parseInspectionDetailStatus(elementValue);
  if (parsedElementValue.length === 0) {
    return null;
  }

  const categories = parsedElementValue.length > 0 
    ? Object.keys(parsedElementValue[0][Object.keys(parsedElementValue[0])[0]])
    : [];

  return (
    <>
      {categories.map((category, idx) => (
        <React.Fragment key={idx}>
          <tr>
            <td colSpan={parsedElementValue.length + 1} style={{ fontWeight: 'bold' }}>
              {category}:
            </td>
          </tr>
          {Object.keys(parsedElementValue[0][Object.keys(parsedElementValue[0])[0]][category]).map((property, propIndex) => (
            <tr key={propIndex}>
              <td>{property}</td>
              {parsedElementValue.map((film: any, filmIndex: any) => {
                const filmKey = Object.keys(film)[0];
                const filmData = film[filmKey];
                return (
                  <td key={`${filmKey}-${category}-${property}`}>
                    <input
                      type="checkbox"
                      checked={filmData[category][property]}
                      onChange={() => handleCheckboxChange(filmKey, category, property, filmIndex)}
                    />
                  </td>
                );
              })}
            </tr>
          ))}
        </React.Fragment>
      ))}
    </>
  );
};  

  return (
    <>
    <Modal open={isModal}
        onClose={() => setIsModal(false)}
        onOpen={() => setIsModal(true)}>
            <Modal.Header>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>{title}{dashboardStore.dashboard.valueForL4Orders && `/${dashboardStore.dashboard.valueForL4Orders}`}{shippingPrep.subTaskName && `/${shippingPrep.subTaskName}`}</div>
                    {
                       (shippingPrep.subTaskstatus === 1 || shippingPrep.subTaskstatus === 2) &&
                        <ButtonGroup>
                          <Button color="yellow" onClick={() => openHold(3)}>Hold</Button> <ButtonOr />
                          <Button color="blue" onClick={() => openComplete(2)}  disabled={isButtonDisabled}>Complete</Button>
                        </ButtonGroup>
                    }
                    {
                        shippingPrep.subTaskstatus === 3 &&
                        <ButtonGroup>
                          <Button onClick={() => openResume(4)}>Resume</Button> <ButtonOr />
                          <Button color="blue" disabled={shippingPrep.subTaskstatus === 3 && isButtonDisabled}onClick={() => openComplete(2)} >Complete</Button>
                        </ButtonGroup>
                    }
                    {
                        shippingPrep.subTaskstatus === 4 &&
                        <ButtonGroup>
                        <Button color="yellow" onClick={() => openHold(3)}>Hold</Button> <ButtonOr />
                        <Button color="blue" onClick={() => openComplete(2)}  disabled={isButtonDisabled}>Complete</Button>
                      </ButtonGroup>
                    }
                    {
                        shippingPrep.subTaskstatus === 0 &&
                        <Button  primary onClick={handleStart}>Start</Button> 
                    }

                </div>
            </Modal.Header>
            <Modal.Content className={shippingPrep.subTaskstatus === 0 ? "ele-disable" : ""}>
                <Form>
                    <Grid stretched columns={1}>
                        {shippingPrep?.elements?.map((meta:any, index:number) => (
                            <Grid.Column>
                            <Components
                                disabled={false}
                                key={index}
                                index={index}
                                elementDetails={meta}
                                onChangeHandler={onChangeHandler}
                                onPhotoClick={()=>{}}
                                getUploadedFiles={() => {}}
                                onConfirmUser={() => {}}
                                saveDynamicTableData={saveDynamicTableData}
                            />
                        </Grid.Column>
                        ))}
                      </Grid> 
                </Form>
                {
                  shippingPrep.subTaskName === 'Inspection Details' && 
                  (
                    <Table border="1">
                      <thead>
                          {renderTableHeaders()}
                      </thead>
                      <tbody>
                          {renderTableBody()}
                      </tbody>
                    </Table>
                  )
                }
            </Modal.Content>
        
          <Modal.Actions>
            <Button color = "green"  disabled={isButtonDisabled  || isLoading} onClick={handleSubmit}> {isLoading && <Loader active inline size='tiny' /> }Submit</Button>
          </Modal.Actions>
        </Modal>
        {
          inspectModal && (<InspectionDetails inspectModal={inspectModal} filmConditions={filmConditions} selectedId={selectedId} setInspectModal={setInspectModal} shippingPrep={shippingPrep} 
           openComplete={openComplete} rowData={rowData} title={title} handleStatus={handleStatus}/>)
        }
        </>
  )
}

export default observer(HFCTaskModal);
